import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameSettingsComponent } from './game-settings.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SuccessMessageComponent } from 'src/app/components/success-message/success-message.component';



@NgModule({
  declarations: [
    GameSettingsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ComponentsModule
  ],
  providers: [
    SuccessMessageComponent
  ]
})
export class GameSettingsModule { }
